export const MinimumCreatedIdeasRequired = 3;
export const MinimumGroupCountRequired = 3;
